"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const addUpdatedControlsToFlattedControls = (updatedControls, flattedControls) => updatedControls.reduce((flattedAccum, updatedControl) => {
    const controlOriginalInfo = flattedAccum[updatedControl.id];
    if (!controlOriginalInfo) {
        throw new Error(`No original info found for control ${updatedControl.id}`);
    }
    const newControlInfo = Object.assign(Object.assign({}, controlOriginalInfo), { control: updatedControl });
    return Object.assign(Object.assign({}, flattedAccum), { [updatedControl.id]: newControlInfo });
}, flattedControls);
exports.default = addUpdatedControlsToFlattedControls;
